export default __webpack_public_path__ + "static/media/Group8862.3507a2bf.svg";